var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reports"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('search-form',{ref:"searchform",attrs:{"showDates":true,"results":_vm.ocManagersFeed.rows,"totalResults":_vm.ocManagersFeed.count,"noResults":'No activity found for selected period.',"options":{
            permalink: 'getOCManagersFeed'
          }}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44ef52ad","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/OCManagersFeed.vue
// module id = 1310
// module chunks = 1